import { Nullable } from 'global';
import { Path, UseFormReturn } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing';
import { CriteriaValue } from 'modules/jsonRulesCriterias/scorecardCriteria/types';
import { z } from 'zod';

export enum CustomScorecardCriteriaType {
  Text = 'text',
  Number = 'number',
  Currency = 'currency',
  Boolean = 'boolean',
}

const customCriteriaCommonValuesSchema = z.object({
  name: z.string(),
  score: z.string(),
  internalId: z.string().uuid(),
  value: z.string().or(z.number()).nullable(),
});

const customCriteriaSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal(CustomScorecardCriteriaType.Text), ...customCriteriaCommonValuesSchema.shape }),
  z.object({ type: z.literal(CustomScorecardCriteriaType.Number), ...customCriteriaCommonValuesSchema.shape }),
  z.object({ type: z.literal(CustomScorecardCriteriaType.Currency), ...customCriteriaCommonValuesSchema.shape }),
  z.object({ type: z.literal(CustomScorecardCriteriaType.Boolean), ...customCriteriaCommonValuesSchema.shape }),
]);

const customCriteriaFormValueSchema = z.record(z.string().uuid(), customCriteriaSchema.nullable());

export interface ScoreCriteriaEntity {
  criteria: Nullable<Record<string, Omit<CriteriaValue, 'fact' | 'isRequiredToQuote'>>>;
  customCriteria?: z.infer<typeof customCriteriaFormValueSchema>;
}

export interface ScoreCriteriasTableContext {
  handleRemoveRow: (index: number) => void;
  form: UseFormReturn<
    ListingForm<ScoreCriteriaEntity, ScoreCriteriasTableContext, string, CustomScorecardCriteriaType>
  >;
}

export type ScoreCriteriasFormPath = Path<ListingForm<ScoreCriteriaEntity>>;
export type CustomCriteria = z.infer<typeof customCriteriaSchema>;

export interface ScoreTierEntity {
  name: string;
  color: string;
  scoreRange: Record<'min' | 'max', string>;
}

export interface ScoreTiersTableContext {
  handleRemoveRow: (index: number) => void;
  form: UseFormReturn<ListingForm<ScoreTierEntity>>;
}
